const mutations = {
  LOGIN(state, user) {
    state.user = user
  },

  LOGOUT(state) {
    state.user = null
  },

  RELOAD(state) {
    state.user = JSON.parse(localStorage.getItem('user'))
  },
}

export default mutations